/** ========================================================================
 * * LoaderGraph Component
 * This component renders a loading bars representing graph.
 * ========================================================================== */

export default function LoaderGraph({ height, width }) {
  return (
    <div
      style={{ height: height || 350, width: width || "85%" }}
      className="grid items-end grid-cols-12 gap-8 mx-auto"
    >
      {Array.from({ length: 12 }).map((_, idx) => {
        return (
          <div
            style={{
              height: `${Math.ceil(Math.random() * 70)}%`,
              marginBottom: `${Math.ceil((height || 350) * 0.1)}px`,
            }}
            key={idx}
            className="self-end rounded-sm bg-stone-700 animate-pulse"
          />
        );
      })}
    </div>
  );
}
